import request from "@/utils/request";

export const getApi = (name, item) => {
  let params = {
    ...item
  };

  return request({
    url: "/m/" + name,
    method: "get",
    params
  });
};
export const purePost = (path, param) => {
  return request({
    url: path,
    method: "post",
    params: param
  });
};

// 20/21
export const getGameListByTeam = team => {
  const season =
    "20/21";

  return request({
    url: `/api/league/${team}`,
    method: "post",
    params: {
      season
    }
  });
};

export const getArticleListByRound = (_type, team, round) => {
  let type = _type ? "start" : "end";
  // wolves
  // uefa_euro
  // esp
  // la_liga
  // premier_leagu
  const season = "20/21";
  if (["wolves", "la_liga", "premier_league"].indexOf(team) == -1) {
    return request({
      url: `/api/news/${type}/${team}`,
      method: "post",
      params: {
        season,
        round: round
      }
    });
  } else {
    return request({
      url: `/api/news/${team}/${type}`,
      method: "post",
      params: {
        season,
        round: round
      }
    });
  }

};

export const getArticleLContext = id => {
  return request({
    url: `/api/news/${id}`,
    method: "post"
  });
};

export const getContextOfGameById = (_type, id) => {
  let type = _type ? "start" : "end";
  return request({
    url: `/api/${type}/report/${id}`,
    method: "post"
  });
};

export const getNewsList = id => {
  return request({
    url: "/api/latest_news_list",
    method: "post",
    data: {
      category: id,
      code: 'web'
    }
  });
};

export const getNewsEntity = id => {
  return request({
    url: `/api/latestnews/${id}`,
    method: "post"
  });
};
// 赛事列表多选
export const gameMultiple = data => {
  return request({
    url: `/api/report/list`,
    method: "post",
    data
  });
};



// WEBPACK FOOTER //
// ./src/api/api.js